import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";

const root = document.getElementById("root");
if (!root) {
  throw new Error("#root element missing in index.html");
}

// Service worker only in production builds (devOptions.enabled = false in vite.config.ts).
async function start() {
  const pwa = import.meta.env.PROD ? await import("@/pwa") : null;
  createRoot(root as HTMLElement).render(
    <StrictMode>
      <App
        {...(pwa ? { updates: pwa.updateStore, onUpdate: () => void pwa.applyUpdate(true) } : {})}
      />
    </StrictMode>,
  );
}

void start();
